import { useCallback, useEffect, useState } from "react";
import { ScrollText, Search, Trash2, Unlink } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDateTime } from "../lib/api";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { FibiLoading } from "../components/FibiLoading";

export default function LogAktivitas() {
  const [logs, setLogs] = useState(null);
  const [topReset, setTopReset] = useState([]);
  const [q, setQ] = useState("");

  const load = useCallback((kw = "") => {
    api.get("/activity-logs", { params: { q: kw || undefined } })
      .then((r) => { setLogs(r.data.logs || []); setTopReset(r.data.top_reset_week || []); })
      .catch((e) => { setLogs([]); toast.error(errMsg(e)); });
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-6" data-testid="log-aktivitas-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-2"><ScrollText className="w-7 h-7 text-[#F04E23]" /> Log Aktivitas</h1>
          <p className="text-sm text-muted-foreground mt-1">Jejak audit: siapa menghapus apa & kapan (200 terbaru).</p>
        </div>
        <form onSubmit={(e) => { e.preventDefault(); load(q); }} className="flex gap-2">
          <Input placeholder="Cari nama / aksi / target..." value={q} onChange={(e) => setQ(e.target.value)} className="w-64" data-testid="input-search-log" />
          <Button type="submit" variant="destructive" data-testid="btn-search-log"><Search className="w-4 h-4 mr-1.5" /> Cari</Button>
        </form>
      </div>
      {topReset.length > 0 && (
        <Card className="bg-amber-500/5 border-amber-500/20" data-testid="top-reset-card">
          <CardContent className="p-4 flex flex-wrap items-center gap-2">
            <span className="text-xs font-semibold text-amber-400">Reset voucher terbanyak 7 hari terakhir:</span>
            {topReset.map((t) => <span key={t.by} className="px-2.5 py-1 rounded-lg bg-amber-500/10 border border-amber-500/20 text-xs font-mono text-amber-300" data-testid={`top-reset-${t.by}`}>{t.by} • {t.count}x</span>)}
          </CardContent>
        </Card>
      )}
      <Card className="bg-card/60 border-border overflow-hidden overflow-x-auto">
        <Table className="min-w-[720px]" data-testid="log-table">
          <TableHeader><TableRow>
            <TableHead>Waktu</TableHead><TableHead>Pengguna</TableHead><TableHead>Aksi</TableHead><TableHead>Target</TableHead><TableHead>Detail</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {logs === null && <TableRow><TableCell colSpan={5} className="p-0"><FibiLoading text="FIBI sedang memuat data..." size={20} /></TableCell></TableRow>}
            {logs !== null && !logs.length && <TableRow><TableCell colSpan={5} className="text-center py-8 text-muted-foreground" data-testid="log-empty">Belum ada aktivitas tercatat</TableCell></TableRow>}
            {(logs || []).map((l) => (
              <TableRow key={l.id} data-testid={`log-row-${l.id}`}>
                <TableCell className="font-mono text-xs whitespace-nowrap">{fmtDateTime(l.created_at)}</TableCell>
                <TableCell><div className="font-medium text-sm">{l.user_name}</div><div className="text-[10px] font-mono text-muted-foreground">{l.user_email}</div></TableCell>
                <TableCell><span className={`inline-flex items-center gap-1.5 text-sm font-medium ${l.action.startsWith("Reset") ? "text-sky-400" : "text-rose-400"}`}>{l.action.startsWith("Reset") ? <Unlink className="w-3.5 h-3.5" /> : <Trash2 className="w-3.5 h-3.5" />}{l.action}</span></TableCell>
                <TableCell className="font-mono text-sm">{l.target}</TableCell>
                <TableCell className="text-xs text-muted-foreground">{l.detail || "-"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
